module.exports = __webpack_public_path__ + "img/resized952016062595143352.7d748b6f.jpg";